import styled from 'styled-components';
import { Typography, getSpacingToken } from '@optimus-web/core';

export const NumberWrapper = styled(Typography).attrs({ textStyle: 'bodyMediumStrong' })`
    width: ${getSpacingToken('500')}px;
    text-align: right;
`;
